export const UserFormFields = [
  'firstName',
  'lastName',
  'address',
  'postcode',
  'city',
  'additionalAccountOwners',
];
